!<!--  -->
<template>
<div class="scence irrigation" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content" ref="content">
      <div class="countryList">
          <div class="country">
              <span>水利工程：</span>
          </div>
          <div class="country" v-for="(item,index) in tabs" :key="index">
              <span @click="categoryChangeOne(index, item.value)" :class="{ 'categoryon': index==choosed }">{{item}}</span>
          </div>
      </div>
      <div class="countryList">
        <div class="townchoose">
          <div class="country">
            <span>行政区划：</span>
          </div>
          <div class="country">
              <span @click="setAllCheck()" :class="{ countryon: all }">全部</span>
          </div>
          <div class="country" v-for="(item,index) in towns" :key="index">
              <span  @click="setListCheck(index, item.adcd)" :class="{ countryon: item.check }">{{item.adnm}}</span>
          </div>
        </div>
      </div>
      <Reservoir v-if="choosed === 0" :addvcd='aDDVCD'></Reservoir>
      <!-- <Sluice v-if="choosed === 1" :addvcd='aDDVCD'></Sluice> -->
      <Dike v-if="choosed === 1" :addvcd='aDDVCD'></Dike>
      <Hillpond v-if="choosed === 2" :addvcd='aDDVCD'></Hillpond>
      <Ponddam v-if="choosed === 3" :addvcd='aDDVCD'></Ponddam>
    </div>
</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// import TownName from '@/components/Townname/index.vue'
import monitorTypes from '@/store/types/monitor'
import Reservoir from '../reservoir/index_com.vue'
import Sluice from '../sluice/index_com.vue'
import Dike from '../dike/index_com.vue'
import Hillpond from '../hillpond/index_com.vue'
import Ponddam from '../ponddam/index_com.vue'
export default {
// import引入的组件需要注入到对象中才能使用
  components: {
    Reservoir,
    Sluice,
    Dike,
    Hillpond,
    Ponddam
  },
  data () {
    // 这里存放数据
    return {
      choosed: 0,
      all: true,
      towns: [],
      checkarr: [],
      isTown: true,
      searchName: '',
      pageIndex: '1',
      pageSize: '100',
      aDDVCD: '330683',
      tabs: ['水库', '堤防', '山塘', '塘堰坝']
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    towndata () {
      let arr = []
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcdtotal = data.total
        this.towns = data.results
        this.towns.forEach(item => {
          let obj = { adcd: '', adnm: '', id: 0, lat: 0.0, lng: 0.0, modifyTime: '', check: false }
          obj.adcd = item.adcd
          if (item.adnm.includes('镇') || item.adnm.includes('乡')) {
            let wordarr = item.adnm
            obj.adnm = wordarr.slice(0, wordarr.length - 1)
          } else if (item.adnm.includes('街道')) {
            let wordarr = item.adnm
            obj.adnm = wordarr.replace('街道', '')
          } else {
            let wordarr = item.adnm
            obj.adnm = wordarr
          }

          obj.id = item.id
          arr.push(obj)
        })
        this.towns = arr
      })
    },
    // 乡镇选择
    setListCheck: function (idx, adcd) {
      this.loading = true
      this.all = false
      var check = this.towns[idx].check
      this.towns[idx].check = !check
      let checknum = this.thecheck()
      this.addcheckarr(adcd, this.towns[idx].check)
      // console.log(adcd, this.towns[idx].check)
      // 拼接截取
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.aDDVCD = ''
        this.checkarr.forEach((item) => {
          this.aDDVCD += item.substring(0, 9) + ','
        })
        this.aDDVCD = this.aDDVCD.substring(0, this.aDDVCD.length - 1)
        // this.tabledata()
      }
      // 0或全选 变为全部
      if (checknum === this.adcdtotal || checknum === 0) {
        this.setAllCheck()
      }
      // this.$emit('townadcd', this.aDDVCD)
      // alert(this.aDDVCD)
    },
    addcheckarr: function (adcd, state) {
      if (state) {
        this.checkarr.push(adcd)
      } else {
        this.deletecheckarr(adcd)
      }
    },
    deletecheckarr: function (adcd) {
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.checkarr.forEach((item, index) => {
          if (item === adcd) {
            this.checkarr.splice(index, 1)
          }
        })
      }
    },
    setAllCheck: function () {
      this.all = true
      this.checkarr = []
      this.aDDVCD = ''
      this.towns.forEach((item) => {
        item.check = false
      })
      // this.$emit('townadcd', this.aDDVCD)
      // this.tabledata()
    },
    thecheck: function () {
      let num = 0
      this.towns.forEach((item) => {
        if (item.check) {
          num++
        }
      })
      return num
    },
    // 切换水利工程
    categoryChangeOne (index, val) {
      this.loading = true
      this.choosed = index
      this.tabledata()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.towndata()
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less" src="@/assets/scene.less" scoped></style>
<style lang='less' scoped>
//@import url(); 引入公共css类
.irrigation{
  overflow: hidden;
}
.countryList{
    height: 92px;
    background-color: #ffffff;
    border-radius: 5px;
    color: #444444;
    font-size: 15px;
    &>div{
      display: block;
    }
    .country{
      float: left;
      font-family: Microsoft YaHei UI;
      font-size: 15px;
      text-align: center;
      margin-top: 20px;
      margin-left: 0.15%;
      cursor: pointer;
      .countryon, .categoryon{
        border-radius: 15px;
        background-color: #fda72c;
        color: #ffffff
      }
      span{
        padding: 4px 12px;
      }
    }
  }
</style>
